// Apolo IDE — BrainQuickActions (Sprint v2 Epic B6 WS B6.2).
//
// Buttons that act on the *current* session: Save current to brain, Open
// vault root in Obsidian, Refresh MCP server.

import { useState } from 'react';
import { FolderOpen, Loader2, RefreshCcw, Save } from 'lucide-react';
import { useAgentStore } from '../../../../store/useAgentStore.js';

export default function BrainQuickActions() {
  const session = useAgentStore((s) => s.code.sessions.find((x) => x.id === s.code.activeSessionId));
  const saveSessionToBrain = useAgentStore((s) => s.saveSessionToBrain);
  const [busy, setBusy] = useState(null); // null | 'save' | 'restart'
  const [lastResult, setLastResult] = useState(null);

  async function doSave() {
    if (!session?.id) return;
    setBusy('save');
    setLastResult(null);
    const r = await saveSessionToBrain(session.id);
    setBusy(null);
    setLastResult(r);
  }

  async function doRestart() {
    if (typeof window === 'undefined' || !window.apolo?.mcp?.restart) return;
    setBusy('restart');
    try { await window.apolo.mcp.restart('obsidian'); } catch { /* swallow */ }
    setBusy(null);
  }

  function openVault() {
    if (typeof window !== 'undefined' && window.apolo?.openInObsidian) {
      window.apolo.openInObsidian('').catch(() => {});
    }
  }

  return (
    <div className="flex flex-col gap-2 p-3">
      <button
        type="button"
        onClick={doSave}
        disabled={!session?.id || busy === 'save'}
        className="inline-flex items-center justify-center gap-1.5 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-2 py-1.5 text-xs text-apolo-textPrimary transition hover:border-apolo-accent disabled:opacity-50"
      >
        {busy === 'save' ? <Loader2 size={12} className="animate-spin" aria-hidden="true" /> : <Save size={12} aria-hidden="true" />}
        Salvar sessão atual
      </button>
      <button
        type="button"
        onClick={openVault}
        className="inline-flex items-center justify-center gap-1.5 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-2 py-1.5 text-xs text-apolo-textPrimary transition hover:border-apolo-accent"
      >
        <FolderOpen size={12} aria-hidden="true" />
        Abrir vault no Obsidian
      </button>
      <button
        type="button"
        onClick={doRestart}
        disabled={busy === 'restart'}
        className="inline-flex items-center justify-center gap-1.5 rounded-md border border-apolo-borderSubtle bg-apolo-surface2 px-2 py-1.5 text-xs text-apolo-textPrimary transition hover:border-apolo-accent disabled:opacity-50"
      >
        {busy === 'restart' ? <Loader2 size={12} className="animate-spin" aria-hidden="true" /> : <RefreshCcw size={12} aria-hidden="true" />}
        Reiniciar MCP server
      </button>

      {lastResult && (
        <p
          role="status"
          className={`text-xs ${lastResult.ok ? 'text-apolo-success' : 'text-apolo-warning'}`}
        >
          {lastResult.ok
            ? `Salvo: ${lastResult.note_path || 'nota criada'}`
            : `Falha: ${lastResult.error || 'erro desconhecido'}${lastResult.dry_run ? ' (daemon offline)' : ''}`}
        </p>
      )}
    </div>
  );
}
